/* Vertex Decants — scripts propios (vanilla JS, sin librerías) */
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
  initResenasMarquee();
  initCatalogoWhatsapp();
  initCarruseles();
  initOfertaFlash();
  initAnuncioMoto();
  initEnvioTimeline();
  initComboBuilder();
});

/* ---------- Pedido / Enviado / Entregado: fechas + cuenta atrás a la hora de corte ---------- */
function initEnvioTimeline() {
  var bloques = document.querySelectorAll('[data-vd-envio]');
  if (!bloques.length) return;

  var meses = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function formatearFecha(fecha) {
    return fecha.getDate() + ' ' + meses[fecha.getMonth()];
  }

  function sumarDias(base, dias) {
    var f = new Date(base);
    f.setDate(f.getDate() + dias);
    return f;
  }

  function formatearRango(diasMin, diasMax) {
    var hoy = new Date();
    var desde = sumarDias(hoy, diasMin);
    var hasta = sumarDias(hoy, diasMax);
    if (diasMin === diasMax) return formatearFecha(desde);
    return formatearFecha(desde) + ' - ' + formatearFecha(hasta);
  }

  function proximoCorte(horaCorte) {
    var ahora = new Date();
    var corte = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), horaCorte, 0, 0, 0);
    if (corte.getTime() <= ahora.getTime()) corte.setDate(corte.getDate() + 1);
    return corte;
  }

  bloques.forEach(function (bloque) {
    var horaCorte = parseInt(bloque.getAttribute('data-vd-hora-corte'), 10);
    if (isNaN(horaCorte)) horaCorte = 18;
    var envioMin = parseInt(bloque.getAttribute('data-vd-envio-min'), 10) || 0;
    var envioMax = parseInt(bloque.getAttribute('data-vd-envio-max'), 10) || envioMin;
    var entregaMin = parseInt(bloque.getAttribute('data-vd-entrega-min'), 10) || 0;
    var entregaMax = parseInt(bloque.getAttribute('data-vd-entrega-max'), 10) || entregaMin;

    var cuentaEl = bloque.querySelector('[data-vd-envio-cuenta]');
    var envioRangoEl = bloque.querySelector('[data-vd-envio-rango]');
    var entregaRangoEl = bloque.querySelector('[data-vd-entrega-rango]');

    if (envioRangoEl) envioRangoEl.textContent = formatearRango(envioMin, envioMax);
    if (entregaRangoEl) entregaRangoEl.textContent = formatearRango(entregaMin, entregaMax);

    function actualizarCuenta() {
      if (!cuentaEl) return;
      var restante = proximoCorte(horaCorte).getTime() - Date.now();
      var horas = Math.floor(restante / 3600000);
      var minutos = Math.floor((restante % 3600000) / 60000);
      cuentaEl.textContent = horas + 'h ' + String(minutos).padStart(2, '0') + 'min';
    }

    actualizarCuenta();
    setInterval(actualizarCuenta, 30000);
  });
}

/* ---------- Moto animada dentro de la barra de aviso superior ---------- */
function initAnuncioMoto() {
  if (!window.vdMotoUrl) return;
  var mensajes = document.querySelectorAll('.announcement-bar__message span');
  if (!mensajes.length) return;

  document.documentElement.style.setProperty('--vd-moto-url', 'url(' + window.vdMotoUrl + ')');

  mensajes.forEach(function (span) {
    if (span.dataset.vdMotoListo) return;
    span.dataset.vdMotoListo = 'true';
    var moto = document.createElement('span');
    moto.className = 'vd-anuncio-moto';
    moto.setAttribute('aria-hidden', 'true');
    span.appendChild(moto);
  });
}

/* ---------- Oferta relámpago: cuenta atrás lineal + barra ---------- */
function initOfertaFlash() {
  var ofertas = document.querySelectorAll('[data-vd-oferta]');
  if (!ofertas.length) return;

  ofertas.forEach(function (oferta, idx) {
    var duracionMin = parseInt(oferta.getAttribute('data-vd-duracion-min'), 10) || 60;
    var duracionMs = duracionMin * 60 * 1000;
    var storageKey = 'vd_oferta_flash_deadline_' + idx;

    var horasEl = oferta.querySelector('[data-vd-horas]');
    var minutosEl = oferta.querySelector('[data-vd-minutos]');
    var segundosEl = oferta.querySelector('[data-vd-segundos]');
    var barraEl = oferta.querySelector('[data-vd-barra]');

    function obtenerLimite() {
      var guardado = null;
      try { guardado = window.localStorage.getItem(storageKey); } catch (e) {}
      var limite = guardado ? parseInt(guardado, 10) : NaN;
      if (!limite || isNaN(limite) || limite <= Date.now()) {
        limite = Date.now() + duracionMs;
        try { window.localStorage.setItem(storageKey, String(limite)); } catch (e) {}
      }
      return limite;
    }

    var limite = obtenerLimite();

    function pad(n) { return String(n).padStart(2, '0'); }

    function actualizar() {
      var restante = limite - Date.now();
      if (restante <= 0) {
        limite = Date.now() + duracionMs;
        try { window.localStorage.setItem(storageKey, String(limite)); } catch (e) {}
        restante = duracionMs;
      }

      var horas = Math.floor(restante / 3600000);
      var minutos = Math.floor((restante % 3600000) / 60000);
      var segundos = Math.floor((restante % 60000) / 1000);

      if (horasEl) horasEl.textContent = pad(horas);
      if (minutosEl) minutosEl.textContent = pad(minutos);
      if (segundosEl) segundosEl.textContent = pad(segundos);
      if (barraEl) barraEl.style.width = ((restante / duracionMs) * 100).toFixed(3) + '%';
    }

    actualizar();
    setInterval(actualizar, 1000);
  });
}

/* ---------- Carrusel de perfumes: puntos, flechas y autoplay ---------- */
function initCarruseles() {
  var carruseles = document.querySelectorAll('[data-vd-carrusel]');
  if (!carruseles.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  carruseles.forEach(function (carrusel) {
    var track = carrusel.querySelector('[data-vd-carrusel-track]');
    var slides = carrusel.querySelectorAll('.vd-carrusel-slide');
    var dots = carrusel.querySelectorAll('[data-vd-dot]');
    var prevBtn = carrusel.querySelector('[data-vd-carrusel-prev]');
    var nextBtn = carrusel.querySelector('[data-vd-carrusel-next]');
    if (!track || slides.length < 2) return;

    var index = 0;
    var total = slides.length;
    var autoplayMs = parseInt(carrusel.getAttribute('data-vd-autoplay'), 10) || 4000;
    var timer = null;

    function irA(i) {
      index = (i + total) % total;
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      dots.forEach(function (dot, di) {
        dot.classList.toggle('vd-dot-activo', di === index);
      });
    }

    function reiniciarAutoplay() {
      if (reduce) return;
      if (timer) clearInterval(timer);
      timer = setInterval(function () { irA(index + 1); }, autoplayMs);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        irA(parseInt(dot.getAttribute('data-vd-dot'), 10));
        reiniciarAutoplay();
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { irA(index - 1); reiniciarAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { irA(index + 1); reiniciarAutoplay(); });

    carrusel.addEventListener('mouseenter', function () { if (timer) clearInterval(timer); });
    carrusel.addEventListener('mouseleave', reiniciarAutoplay);

    irA(0);
    reiniciarAutoplay();
  });
}

/* ---------- Catálogo de la portada: botón "Pedir por WhatsApp" por tarjeta ---------- */
function initCatalogoWhatsapp() {
  var tarjetas = document.querySelectorAll('[data-vd-catalogo-card]');
  if (!tarjetas.length) return;

  tarjetas.forEach(function (tarjeta) {
    var numero = tarjeta.getAttribute('data-vd-wa-numero');
    var base = tarjeta.getAttribute('data-vd-wa-base');
    var boton = tarjeta.querySelector('[data-vd-wa-btn]');
    var radios = tarjeta.querySelectorAll('[data-vd-talla]');
    if (!boton || !radios.length) return;

    function actualizarEnlace() {
      var activo = tarjeta.querySelector('[data-vd-talla]:checked');
      var talla = activo ? activo.getAttribute('data-vd-talla') : '';
      var mensaje = base + (talla ? ' (' + talla + ')' : '');
      boton.href = 'https://wa.me/' + numero + '?text=' + encodeURIComponent(mensaje);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', actualizarEnlace);
    });
    actualizarEnlace();
  });
}

/* ---------- Reveal on scroll ---------- */
function initReveal() {
  var els = document.querySelectorAll('.vd-reveal, .vd-reveal-scale');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) {
    els.forEach(function (el) { el.classList.add('vd-visible'); });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('vd-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );

  els.forEach(function (el, i) {
    el.style.setProperty('--vd-i', i % 6);
    observer.observe(el);
  });
}

/* ---------- Galería de la página de producto ---------- */
function initGaleriaProducto() {
  var principal = document.querySelector('[data-vd-galeria-principal]');
  var minis = document.querySelectorAll('[data-vd-mini]');
  if (!principal || !minis.length) return;

  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var url = mini.getAttribute('data-vd-mini');
      if (!url) return;
      principal.src = url;
      minis.forEach(function (m) { m.classList.remove('vd-mini-activa'); });
      mini.classList.add('vd-mini-activa');
    });
  });
}

/* ---------- Selector de variantes (talla) en la página de producto ---------- */
function initVariantesProducto() {
  var form = document.querySelector('[data-vd-form-producto]');
  if (!form) return;

  var dataEl = document.querySelector('[data-vd-variantes-json]');
  if (!dataEl) return;

  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var idInput = form.querySelector('[name="id"]');
  var addBtn = form.querySelector('[data-vd-add-btn]');
  var precioActual = document.querySelector('[data-vd-precio-actual]');
  var precioAnterior = document.querySelector('[data-vd-precio-anterior]');
  var pillGrupos = document.querySelectorAll('[data-vd-opcion-grupo]');

  function formatearPrecio(centavos) {
    var el = document.querySelector('[data-vd-precio-actual]');
    var formato = el ? el.getAttribute('data-vd-formato') : null;
    if (formato) {
      return formato.replace('[amount]', (centavos / 100).toFixed(2));
    }
    return (centavos / 100).toFixed(2);
  }

  function seleccionActual() {
    var seleccion = [];
    pillGrupos.forEach(function (grupo) {
      var activa = grupo.querySelector('.vd-pill-activa');
      seleccion.push(activa ? activa.getAttribute('data-vd-valor') : null);
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = seleccionActual();
    return variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;

    idInput.value = variante.id;

    if (precioActual) precioActual.textContent = formatearPrecio(variante.price);
    if (precioAnterior) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnterior.textContent = formatearPrecio(variante.compare_at_price);
        precioAnterior.style.display = '';
      } else {
        precioAnterior.style.display = 'none';
      }
    }

    if (addBtn) {
      if (variante.available) {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.getAttribute('data-vd-texto-disponible') || addBtn.textContent;
      } else {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.getAttribute('data-vd-texto-agotado') || 'Agotado';
      }
    }

    // Deshabilita combinaciones imposibles en el siguiente selector
    pillGrupos.forEach(function (grupo, idx) {
      var pills = grupo.querySelectorAll('.vd-pill');
      pills.forEach(function (pill) {
        var valorPrueba = seleccionActual();
        valorPrueba[idx] = pill.getAttribute('data-vd-valor');
        var existe = variantes.some(function (v) {
          return v.options.every(function (opt, i) { return opt === valorPrueba[i]; });
        });
        pill.disabled = !existe;
      });
    });
  }

  pillGrupos.forEach(function (grupo) {
    grupo.querySelectorAll('.vd-pill').forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.disabled) return;
        grupo.querySelectorAll('.vd-pill').forEach(function (p) { p.classList.remove('vd-pill-activa'); });
        pill.classList.add('vd-pill-activa');
        actualizar();
      });
    });
  });

  actualizar();
}

/* ---------- Reseñas: pausa el marquee si el usuario prefiere menos movimiento ---------- */
function initResenasMarquee() {
  var track = document.querySelector('.vd-resenas-track');
  if (!track) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    track.style.animation = 'none';
  }
}

/* ---------- Arma tu combo: categoría → tamaño → perfumes, con descuento y envío gratis ---------- */
function initComboBuilder() {
  var combo = document.querySelector('[data-vd-combo]');
  if (!combo) return;

  var descuentoPct = parseFloat(combo.getAttribute('data-vd-combo-descuento-pct')) || 0;
  var descuentoMin = parseInt(combo.getAttribute('data-vd-combo-descuento-min'), 10) || 2;
  var envioUmbral = parseFloat(combo.getAttribute('data-vd-combo-envio-umbral')) || 0;
  var whatsappNumero = combo.getAttribute('data-vd-combo-whatsapp') || '';

  var pasos = combo.querySelectorAll('[data-vd-combo-paso]');
  var botonesCat = combo.querySelectorAll('[data-vd-combo-cat]');
  var bloqueTamano = combo.querySelector('[data-vd-combo-bloque-tamano]');
  var botonesTam = combo.querySelectorAll('[data-vd-combo-tam]');
  var bloquePerfumes = combo.querySelector('[data-vd-combo-bloque-perfumes]');
  var buscar = combo.querySelector('[data-vd-combo-buscar]');
  var tarjetas = combo.querySelectorAll('[data-vd-combo-item]');

  var vacioEl = combo.querySelector('[data-vd-combo-vacio]');
  var listaEl = combo.querySelector('[data-vd-combo-lista]');
  var countEl = combo.querySelector('[data-vd-combo-count]');
  var ahorroBox = combo.querySelector('[data-vd-combo-ahorro-box]');
  var ahorroEl = combo.querySelector('[data-vd-combo-ahorro]');
  var envioBox = combo.querySelector('[data-vd-combo-envio-box]');
  var envioTextoEl = combo.querySelector('[data-vd-combo-envio-texto]');
  var envioBarraEl = combo.querySelector('[data-vd-combo-envio-barra]');
  var preciosBox = combo.querySelector('[data-vd-combo-precios]');
  var subtotalEl = combo.querySelector('[data-vd-combo-subtotal]');
  var filaDescuento = combo.querySelector('[data-vd-combo-fila-descuento]');
  var descuentoEl = combo.querySelector('[data-vd-combo-descuento]');
  var totalBox = combo.querySelector('[data-vd-combo-total-box]');
  var totalEl = combo.querySelector('[data-vd-combo-total]');
  var btnCheckout = combo.querySelector('[data-vd-combo-checkout]');
  var btnWhatsapp = combo.querySelector('[data-vd-combo-whatsapp-btn]');

  var categoriaActual = 'todos';
  var tamanoActual = null;
  var seleccionados = {}; // handle -> { nombre, handle, precio, imagen }

  function precioPorTamano(tarjeta, tamano) {
    if (tamano === '3 ML') return parseFloat(tarjeta.getAttribute('data-precio-3')) || 0;
    if (tamano === '5 ML') return parseFloat(tarjeta.getAttribute('data-precio-5')) || 0;
    if (tamano === '10 ML') return parseFloat(tarjeta.getAttribute('data-precio-10')) || 0;
    return 0;
  }

  function fmt(n) {
    return 'S/ ' + n.toFixed(2).replace(/\.00$/, '');
  }

  function marcarPaso(numero) {
    pasos.forEach(function (p) {
      var n = parseInt(p.getAttribute('data-vd-combo-paso'), 10);
      p.classList.remove('is-active', 'is-done');
      if (n < numero) p.classList.add('is-done');
      if (n === numero) p.classList.add('is-active');
    });
  }

  function filtrarPerfumes() {
    var texto = (buscar && buscar.value || '').trim().toLowerCase();
    tarjetas.forEach(function (tarjeta) {
      var cat = tarjeta.getAttribute('data-categoria');
      var nombre = (tarjeta.getAttribute('data-nombre') || '').toLowerCase();
      var pasaCategoria = categoriaActual === 'todos' || cat === categoriaActual;
      var pasaTexto = texto === '' || nombre.indexOf(texto) !== -1;
      tarjeta.classList.toggle('is-hidden', !(pasaCategoria && pasaTexto));
    });
  }

  function actualizarPreciosTarjetas() {
    if (!tamanoActual) return;
    tarjetas.forEach(function (tarjeta) {
      var handle = tarjeta.getAttribute('data-handle');
      if (seleccionados[handle]) {
        seleccionados[handle].precio = precioPorTamano(tarjeta, tamanoActual);
      }
    });
  }

  function recalcular() {
    var handles = Object.keys(seleccionados);
    var cantidad = handles.length;

    if (cantidad === 0) {
      if (vacioEl) vacioEl.style.display = '';
      if (listaEl) listaEl.innerHTML = '';
      if (ahorroBox) ahorroBox.style.display = 'none';
      if (envioBox) envioBox.style.display = 'none';
      if (preciosBox) preciosBox.style.display = 'none';
      if (totalBox) totalBox.style.display = 'none';
      if (btnCheckout) btnCheckout.disabled = true;
      if (btnWhatsapp) btnWhatsapp.style.display = 'none';
      if (countEl) countEl.textContent = '0 items';
      return;
    }

    if (vacioEl) vacioEl.style.display = 'none';
    if (countEl) countEl.textContent = cantidad + (cantidad === 1 ? ' item' : ' items');

    if (listaEl) {
      listaEl.innerHTML = '';
      handles.forEach(function (handle) {
        var item = seleccionados[handle];
        var li = document.createElement('li');
        li.className = 'vd-combo-lista-item';
        li.innerHTML =
          '<img src="' + item.imagen + '" alt="">' +
          '<div class="vd-combo-lista-info">' +
            '<span class="vd-combo-lista-nombre">' + item.nombre + '</span>' +
            '<span class="vd-combo-lista-meta">' + tamanoActual + '</span>' +
          '</div>' +
          '<span class="vd-combo-lista-precio">' + fmt(item.precio) + '</span>' +
          '<button type="button" class="vd-combo-lista-quitar" data-quitar="' + handle + '">✕</button>';
        listaEl.appendChild(li);
      });
      listaEl.querySelectorAll('[data-quitar]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var handle = btn.getAttribute('data-quitar');
          delete seleccionados[handle];
          var tarjeta = combo.querySelector('[data-vd-combo-item][data-handle="' + handle + '"]');
          if (tarjeta) tarjeta.classList.remove('is-selected');
          recalcular();
        });
      });
    }

    var subtotal = handles.reduce(function (sum, h) { return sum + seleccionados[h].precio; }, 0);
    var aplicaDescuento = cantidad >= descuentoMin && descuentoPct > 0;
    var descuento = aplicaDescuento ? subtotal * (descuentoPct / 100) : 0;
    var total = subtotal - descuento;

    if (preciosBox) preciosBox.style.display = '';
    if (subtotalEl) subtotalEl.textContent = fmt(subtotal);
    if (filaDescuento) filaDescuento.style.display = aplicaDescuento ? '' : 'none';
    if (descuentoEl) descuentoEl.textContent = '-' + fmt(descuento);

    if (ahorroBox) ahorroBox.style.display = aplicaDescuento ? '' : 'none';
    if (ahorroEl) ahorroEl.textContent = fmt(descuento);

    if (envioUmbral > 0) {
      if (envioBox) envioBox.style.display = '';
      var faltante = envioUmbral - total;
      var progreso = Math.min(100, (total / envioUmbral) * 100);
      if (envioBarraEl) envioBarraEl.style.width = progreso + '%';
      if (envioTextoEl) {
        envioTextoEl.textContent = faltante > 0
          ? '🚚 Te faltan ' + fmt(faltante) + ' para envío gratis'
          : '🚚 ¡Tu combo ya tiene envío gratis!';
      }
    }

    if (totalBox) totalBox.style.display = '';
    if (totalEl) totalEl.textContent = fmt(total);

    if (btnCheckout) btnCheckout.disabled = false;

    if (btnWhatsapp && whatsappNumero) {
      var lineas = handles.map(function (h) {
        var item = seleccionados[h];
        return '- ' + item.nombre + ' (' + tamanoActual + '): ' + fmt(item.precio);
      });
      var mensaje = 'Hola, quiero pedir este combo:\n' + lineas.join('\n') + '\n\nTotal: ' + fmt(total);
      btnWhatsapp.href = 'https://wa.me/' + whatsappNumero + '?text=' + encodeURIComponent(mensaje);
      btnWhatsapp.style.display = '';
    }
  }

  botonesCat.forEach(function (btn) {
    btn.addEventListener('click', function () {
      botonesCat.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      categoriaActual = btn.getAttribute('data-vd-combo-cat');
      filtrarPerfumes();
      if (bloqueTamano) bloqueTamano.classList.remove('vd-combo-locked');
      marcarPaso(2);
    });
  });

  botonesTam.forEach(function (btn) {
    btn.addEventListener('click', function () {
      botonesTam.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      tamanoActual = btn.getAttribute('data-vd-combo-tam');
      actualizarPreciosTarjetas();
      recalcular();
      if (bloquePerfumes) bloquePerfumes.classList.remove('vd-combo-locked');
      marcarPaso(3);
    });
  });

  if (buscar) buscar.addEventListener('input', filtrarPerfumes);

  tarjetas.forEach(function (tarjeta) {
    tarjeta.addEventListener('click', function () {
      if (!tamanoActual) return;
      var handle = tarjeta.getAttribute('data-handle');
      if (seleccionados[handle]) {
        delete seleccionados[handle];
        tarjeta.classList.remove('is-selected');
      } else {
        seleccionados[handle] = {
          nombre: tarjeta.getAttribute('data-nombre'),
          handle: handle,
          precio: precioPorTamano(tarjeta, tamanoActual),
          imagen: tarjeta.querySelector('img') ? tarjeta.querySelector('img').src : ''
        };
        tarjeta.classList.add('is-selected');
      }
      recalcular();
    });
  });

  if (btnCheckout) {
    btnCheckout.addEventListener('click', function () {
      var handles = Object.keys(seleccionados);
      if (!handles.length || !tamanoActual) return;
      btnCheckout.disabled = true;
      btnCheckout.textContent = 'Preparando tu pedido...';

      Promise.all(handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (producto) {
            var variante = producto.variants.find(function (v) {
              return v.title === tamanoActual || (v.options && v.options.indexOf(tamanoActual) !== -1);
            });
            return variante ? { id: variante.id, quantity: 1 } : null;
          });
      })).then(function (items) {
        items = items.filter(Boolean);
        if (!items.length) throw new Error('No se encontraron variantes');
        return fetch('/cart/clear.js', { method: 'POST' })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: items })
            });
          });
      }).then(function (r) {
        if (!r.ok) throw new Error('No se pudo agregar al carrito');
        window.location.href = '/checkout';
      }).catch(function () {
        btnCheckout.disabled = false;
        btnCheckout.textContent = 'Finalizar pedido';
        alert('Hubo un problema al preparar tu pedido. Por favor pide por WhatsApp o inténtalo de nuevo.');
      });
    });
  }

  marcarPaso(1);
  filtrarPerfumes();
}
